import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { InputModule } from '../forms/input/input.module';
import { ModalDocumentoOutroComponent } from './modal-documento-outro.component';

@NgModule({
  declarations: [ModalDocumentoOutroComponent],
  imports: [
    // root
    CommonModule,
    IonicModule,
    ReactiveFormsModule,

    // Usucampeao
    InputModule,
  ],
  exports: [ModalDocumentoOutroComponent],
})
export class ModalDocumentoOutroModule { }
